import React, { useState, useEffect , useContext} from 'react'
import Wrapper from '../../../components/common/Wrapper/Wrapper'
import molecules from '../../../components/molecules';
import organisms from '../../../components/organisms';
import service from '../../../api/services';
import { ShowActiveTab } from "../../../Context"
import { useToasts } from 'react-toast-notifications';
import { useNavigate } from 'react-router';
const { TopBar } = molecules
const { Warranty } = organisms

const Index = () => {
  const { addToast } = useToasts();
  const navigate = useNavigate()

  const { setActiveTab }: any = useContext(ShowActiveTab)
  const [warrantyProductData, setWarrantyProductData] = useState<any>()
  const [searchDetail, setSearchDetail] = useState({
    invoice_number: "",
    modal_number: "",
  })

  const warrantyProductList = async () => {
    try {
      const response = await service?.warrantyService?.warrantyProductList({ invoice_number: searchDetail?.invoice_number, modal_number: searchDetail?.modal_number })
      if (response.status === 200) {
        setWarrantyProductData(response?.data?.data)
      }
    } catch (error: any) {
      console.error(error)
      addToast(error.response.data.message, {
          appearance: 'error',
          autoDismiss: true,
          autoDismissTimeout: 3000,
      });
  }
  }

  const handleChange = (name: string, value: string) => {
    setSearchDetail({ ...searchDetail, [name]: value })
  }

  const handleWarrantyClaim=async(id:string | null)=>{
    if(!id) return null;
    try {
      const response = await service.warrantyService.warrantyClaimCheck(id)
      if (response.status === 200 || response.status === 201) {
        navigate(`/warranty-detail/${id}?isWarranty=true`)
      }
    } catch (error:any) {
      console.error(error)
      addToast(error.response.data.message, {
          appearance: 'error',
          autoDismiss: true,
          autoDismissTimeout: 3000,
      });
    }
  }

  useEffect(() => { setActiveTab("New Claim") }, [])

  return (
    <Wrapper>
      <div className='row align-items-center'>
        <TopBar heading='New Warranty' />
      </div>
      <div className='mt-3'>
        <Warranty
          warrantyProductData={warrantyProductData}
          warrantyProductList={() => warrantyProductList()}
          handleChange={(name: string, value: string) => handleChange(name, value)}
          searchDetail={searchDetail}
          handleWarrantyClaim={(id:string)=>handleWarrantyClaim(id)}
        />
      </div>
    </Wrapper>
  )
}

export default Index